import { h } from 'preact'
import { StepFooter } from '../step-footer'
import { BookingStep } from '../../models/enums'
import { useStateValue } from '../../state-management/store'
import { changeStep } from '../../state-management/actions'

interface Props {
    backStep?: BookingStep
    nextStep?: BookingStep
    isNextDisabled?: boolean
    nextLabel?: string | JSX.Element
    onNext?: () => void
}

const SelfSchedulerFooter: preact.FunctionalComponent<Props> = ({
    backStep,
    nextStep,
    isNextDisabled,
    nextLabel = 'Next ›',
    onNext,
}) => {
    const [{}, dispatch] = useStateValue()

    const handleChangeStep = (bookingStep?: BookingStep) => () => {
        if (typeof bookingStep === 'number') changeStep(dispatch, bookingStep)
    }

    const handleClearPreviousErrors = () => {
        dispatch({
            type: 'HANDLE_ERROR',
            errorMessage: '',
            statusCode: '',
        })
    }

    const handleClickNext = () => {
        if (onNext !== undefined) {
            onNext()
        } else if (nextStep !== undefined) {
            if (nextStep === BookingStep.RESERVING) {
                handleClearPreviousErrors()
            }
            handleChangeStep(nextStep)()
        }
    }

    return (
        <StepFooter
            backStep={backStep}
            nextStep={nextStep}
            isNextDisabled={isNextDisabled}
            nextLabel={nextLabel}
            onNext={handleClickNext}
            onBack={handleChangeStep(backStep)}
        />
    )
}

export default SelfSchedulerFooter
